import { type FC, type PropsWithChildren, useId } from 'react';

import { Box, Card, Stretch } from '@eneco/sparky';

import { ProductCardContent, type ProductCardContentProps } from './ProductCardContent';

interface Props extends Omit<ProductCardContentProps, 'titlePrefix'> {
  isOpen?: boolean;
}

export const PromotionCard: FC<PropsWithChildren<Props>> = ({
  title,
  ribbon,
  touRibbon,
  tag,
  price,
  isOpen,
  usps,
  children,
}) => {
  const contentId = useId();
  const WrapperComponent = isOpen ? Box : Stretch;

  return (
    <WrapperComponent>
      <Card>
        <ProductCardContent
          id={contentId}
          title={title}
          ribbon={ribbon}
          touRibbon={touRibbon}
          tag={tag}
          price={price}
          usps={usps}>
          {children}
        </ProductCardContent>
      </Card>
    </WrapperComponent>
  );
};
